<script setup lang="ts">
const emit = defineEmits<{ (e: 'update:modelValue', val: boolean): void }>();
const props = defineProps<{
  id?: string;
  modelValue: boolean;
}>();

const toggle = () => {
  emit('update:modelValue', !props.modelValue);
};
</script>

<template>
  <div class="flex items-center justify-between m-1">
    <slot />
    <div
      :aria-label="`toggle-button${id ? `-${id}` : ''}`"
      :class="modelValue ? 'bg-nuts-lime-800' : 'bg-neutral-300'"
      class="flex items-center h-4 transition-all duration-100 rounded-full cursor-pointer w-9"
      @click="toggle"
      data-test="toggle-button"
      @keydown.enter="toggle"
      role="button"
      tabindex="0"
    >
      <div
        :class="{ 'translate-x-5': modelValue }"
        class="w-5 h-5 transition-all transform bg-white border border-solid rounded-full shadow-md duration-450 border-neutral-300"
      />
    </div>
  </div>
</template>
